import React from 'react';
import Icon from '../../../components/AppIcon';

const ExpertRating = ({ ratings }) => {
  const getScoreColor = (score) => {
    if (score >= 9) return 'text-success';
    if (score >= 7) return 'text-accent';
    if (score >= 5) return 'text-warning';
    return 'text-destructive';
  };

  const getScoreBackground = (score) => {
    if (score >= 9) return 'bg-success/10';
    if (score >= 7) return 'bg-accent/10';
    if (score >= 5) return 'bg-warning/10';
    return 'bg-destructive/10';
  };

  return (
    <div className="bg-white rounded-xl shadow-subtle border border-border p-6 mb-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
          <Icon name="Award" size={20} className="text-primary" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-text-primary">Expert Rating Breakdown</h2>
          <p className="text-sm text-muted-foreground">Comprehensive testing results</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {ratings?.map((rating, index) => (
          <div key={index} className="space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Icon name={rating?.icon} size={16} className="text-muted-foreground" />
                <span className="font-medium text-text-primary">{rating?.category}</span>
              </div>
              <div className={`px-2 py-1 rounded-lg text-sm font-bold ${getScoreColor(rating?.score)} ${getScoreBackground(rating?.score)}`}>
                {rating?.score}/10
              </div>
            </div>
            
            <div className="w-full bg-muted rounded-full h-2">
              <div
                className={`h-2 rounded-full transition-all duration-500 ${
                  rating?.score >= 9 ? 'bg-success' :
                  rating?.score >= 7 ? 'bg-accent' :
                  rating?.score >= 5 ? 'bg-warning' : 'bg-destructive'
                }`}
                style={{ width: `${rating?.score * 10}%` }}
              />
            </div>
            
            <p className="text-xs text-muted-foreground leading-relaxed">
              {rating?.description}
            </p>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <div>
            <span className="text-sm text-muted-foreground">Overall Expert Score</span>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-2xl font-bold text-primary">
                {(ratings?.reduce((sum, r) => sum + r?.score, 0) / ratings?.length)?.toFixed(1)}
              </span>
              <span className="text-sm text-muted-foreground">/10</span>
            </div>
          </div>
          <div className="text-right">
            <div className="text-sm text-muted-foreground">Testing Period</div>
            <div className="font-medium text-text-primary">6 Months</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpertRating;